import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { FieldBaseComponent } from '../field-base/field-base.component';
import { TextMasks, TextUnmasks, unmask } from '../text-mask';
import { Subscription } from 'rxjs';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'samplicity-text-inline-input',
  templateUrl: './text-inline-input.component.html',
  styleUrls: ['./text-inline-input.component.scss']
})
export class TextInlineInputComponent extends FieldBaseComponent implements OnInit, OnDestroy {

  @Input() type = 'text';
  @Input() maxLength: number;
  @Input() textMask: string;
  @Input() readonly = false;
  @Input() tableLabel = false;
  @Input() colon = true;
  @Input() forceRequiredLabel = false;

  maskSub: Subscription = new Subscription();
  masks: object;

  constructor(
    cd: ChangeDetectorRef,
    private translationService: L10nTranslationService
  ) {
    super(cd);
    this.masks = TextMasks;
  }

  ngOnInit() {
    if (this.textMask) {
      this.maskSub = unmask(this.parentFormGroup.get(this.name)!, TextUnmasks[this.textMask]);
    }
    if (this.control) {
      this.control.valueChanges.subscribe((val) => {
        if (val === '' && this.control) {
          this.control.setValue(null);
        }
      });
    }
  }

  ngOnDestroy() {
    this.maskSub.unsubscribe();
  }
  
  get lang (): string{
    return this.translationService.getLocale().language
  }
  
  onBlur() {
    if (this.control.value) {
      const trimmed = this.control.value.trim();
      if (trimmed !== this.control.value) {
        this.control.setValue(trimmed);
      }
    }
  }
}
